import { mapToCanActivate, mapToResolve, mapToCanDeactivate } from "@angular/router";
import { WorkOrderComponent } from "./components/work-order/work-order.component";
import { WorkOrderDetailComponent } from "./components/work-order/work-order-detail/work-order-detail.component";
import { WorkOrderResolver } from "./resolvers/work-order.resolver";
import { ScanOrderResolver } from "./resolvers/scan-order.resolver";
import { PaymentResolver } from "./resolvers/payment.resolver";
import { OrganizationEditComponent } from "./components/organization/organization-edit.component";
import { OrganizationResolver } from "./resolvers/organization.resolver";
import { OrganizationDetailComponent } from "./components/organization/organization-detail.component";
import { PermitComponent } from "./components/permit/permit.component";

import { BaseGuardService } from "../auth/guards/base-guard.service";
import { InternalGuardService } from "../auth/guards/internal-guard.service";
import { SystemPermissionGuardService } from "../auth/guards/system-permission-guard.service";
import { CanDeactivateGuardService } from "../auth/guards/can-deactivate-guard.service";
import { LunaClaimValues, LunaClaimTypes } from "../models/user-identity.model";
import { OrganizationListComponent } from "./components/organization/components/organization-list.component";
import { UploadScannedDocumentsComponent } from "./components/upload-scanned-documents/upload-scanned-documents.component";
import { PaymentProcessingComponent } from "./components/payment-processing/payment-processing.component";
import { OrganizationWrapperComponent } from "./components/organization/components/organization-wrapper/organization-wrapper.component";
import { OrganizationWellDetailsComponent } from "./components/organization/components/organization-well-details/organization-well-details.component";
import { WellResolver } from "../wells/resolvers/well.resolver";
import { OrgFilePageComponent } from "./components/organization/org-file-page.component";
import { UploadViewFilesComponent } from "./components/fileUpload/upload-view-files.component";
import { DocumentSearchComponent } from './components/document-search/document-search.component';
import { OrganizationMassMailingComponent } from "./components/organization/components/organization-mass-mailing.component";
import { MasterGuardService } from "../auth/guards/master-guard.service";
import { GuardList } from "../auth/guards/guard-list.enum";
const internalGuards = [BaseGuardService, InternalGuardService];
const organizationAdminGuards = [BaseGuardService, InternalGuardService, SystemPermissionGuardService];
const baseGuard = [BaseGuardService];
const systemPermissionGuards = [BaseGuardService, SystemPermissionGuardService];
const deactivateGuards = [ CanDeactivateGuardService ]

export const COMMON_ROUTES: any = [
    {
        path: "organizations",
        component: OrganizationListComponent,
        canActivate: mapToCanActivate(organizationAdminGuards),
        data: { permission: LunaClaimValues.ManageAnyOrganization }
    },
    {
        path: "organizations-mailing",
        component: OrganizationMassMailingComponent,
        canActivate: mapToCanActivate(organizationAdminGuards),
        data: { permission: LunaClaimValues.ManageAnyOrganization }
    },
    {
        path: "org-files",
        component: OrgFilePageComponent,
        canActivate: mapToCanActivate(baseGuard)        
    },
    {
        path: 'organization/:organizationId',
        
        component: OrganizationWrapperComponent,
        resolve: { organization: OrganizationResolver },
        children: [
            {
                path: 'well/:id',
                resolve: { well: mapToResolve(WellResolver) },
                data: { permission: "", claims: [{ type: LunaClaimTypes.Widget, value: LunaClaimValues.ViewWellSearchWidget }], guards: [GuardList.BaseGuardService, GuardList.InternalGuardService, GuardList.SystemPermissionGuardService] },
                canActivate: mapToCanActivate([MasterGuardService]),
                component: OrganizationWellDetailsComponent,
                canDeactivate: mapToCanDeactivate(deactivateGuards)
            },
            {
                path: '',
                data: { permission: LunaClaimValues.ManageAnyOrganization, guards: [GuardList.BaseGuardService, GuardList.InternalGuardService, GuardList.SystemPermissionGuardService] },
                canActivate: mapToCanActivate([MasterGuardService]),
				component: OrganizationDetailComponent,
				canDeactivate: mapToCanDeactivate(deactivateGuards)
            }
        ]
    },
    {
        path: "organization/:organizationId",
        component: OrganizationEditComponent,
        resolve: { organization: mapToResolve(OrganizationResolver) },
        canActivate: mapToCanActivate(organizationAdminGuards),
        data: { permission: LunaClaimValues.ManageAnyOrganization }
    },
    {
        path: "organization",
        component: OrganizationEditComponent,
		resolve: { organization: mapToResolve(OrganizationResolver) },
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.ManageOwnOrganization }
    },
    {
        path: "permit/:permitId",
        component: PermitComponent,
        canActivate: mapToCanActivate(baseGuard)
    },
    {
        path: "work-order",
        component: WorkOrderComponent,
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.ManageWorkOrders }
    },
    {
        path: "work-order/:workOrderId",
        component: WorkOrderDetailComponent,
        resolve: { workOrder: mapToResolve(WorkOrderResolver) },
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.ManageWorkOrders }
    },
    {
        path: "upload-scans/:workOrderId",
        component: UploadScannedDocumentsComponent,
        resolve: { workflow: mapToResolve(ScanOrderResolver) },
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: "", claims: [{ type: LunaClaimTypes.Widget, value: LunaClaimValues.ViewScanningWidget }, { type: LunaClaimTypes.System, value: LunaClaimValues.ManageWorkOrders }] }
    },
    {
        path: "process-payments/:organizationId",
        component: PaymentProcessingComponent,
        resolve: { payments: mapToResolve(PaymentResolver) },
        canActivate: mapToCanActivate(systemPermissionGuards),
        canDeactivate: mapToCanDeactivate(deactivateGuards),
        data: { permission: "", claims: [{ type: LunaClaimTypes.Widget, value: LunaClaimValues.ViewPendingPaymentsWidget }, { type: LunaClaimTypes.System, value: LunaClaimValues.ManageWorkOrders }] }
    },
    {
        path: "upload-view-files",
        component: UploadViewFilesComponent,
        canActivate: mapToCanActivate(baseGuard)
    },
    {
        path: "documents",
        canActivate: mapToCanActivate(baseGuard),
        children: [
            {
                path: '',
                component: DocumentSearchComponent
            }
        ]
    }
]